import { acpDigitalWalletStates } from './states';

export default (appModule) => {
  appModule.config(acpDigitalWalletStates);
};
